let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("97SFQ")).then(() => parcelRequire('43FZt'));